import { createContext, useContext } from 'react';

/**
 * Provides the Mobile Teams screen's locally-fetched homepages + team
 * assignments + refetch callbacks to descendants (DashboardCard →
 * DashboardCardMenu → useHomepageCardRegistry). Lets useHomepageCardRegistry
 * hit the feature-config API surface directly (same path web teams use)
 * instead of going through Redux thunks.
 */
export const MobileTeamsDataContext = createContext({
  homepagesById: {},
  homepages: null, // { defaultDashboards, teamsDashboards } team assignments
  refetchHomepages: () => {},
  refetchTeamsV2: () => {}
});

export function useMobileTeamsData() {
  return useContext(MobileTeamsDataContext);
}
